import { ValidatorRuleModel } from './types';
import { interpolateValidationString } from './util';

export const interpolateValidationRule = (rule: ValidatorRuleModel, replacementTokensToValue: string[][], replacementNumbersToValue: string[]): string => {
    return interpolateValidationString(rule.FieldMessage, replacementTokensToValue, replacementNumbersToValue);
};
